import EmailSpellChecker, {
    POPULAR_DOMAINS,
    POPULAR_TLDS,
} from "@zootools/email-spell-checker";

// Spots likely typos in an email's domain ("gmial.com", "yahoo.con") and
// suggests the fix, using @zootools/email-spell-checker (a maintained fork of
// mailcheck). Only ever a suggestion: real domains that look like typos exist,
// so nothing is blocked.

// Domains customers commonly use, on top of the library's list. A domain on
// the list is never "corrected", which keeps real near neighbors (mac.com /
// mail.com, yahoo.ca / yahoo.com) from being flagged.
export const COMMON_DOMAINS = [
    "gmail.com",
    "googlemail.com",
    "yahoo.com",
    "yahoo.ca",
    "yahoo.co.uk",
    "ymail.com",
    "rocketmail.com",
    "hotmail.com",
    "hotmail.ca",
    "hotmail.co.uk",
    "outlook.com",
    "live.com",
    "live.ca",
    "msn.com",
    "aol.com",
    "aim.com",
    "icloud.com",
    "me.com",
    "mac.com",
    "comcast.net",
    "att.net",
    "sbcglobal.net",
    "bellsouth.net",
    "verizon.net",
    "charter.net",
    "cox.net",
    "frontier.com",
    "frontiernet.net",
    "windstream.net",
    "earthlink.net",
    "centurylink.net",
    "optonline.net",
    "rogers.com",
    "shaw.ca",
    "sympatico.ca",
    "proton.me",
    "protonmail.com",
    "mail.com",
    "email.com",
    "gmx.com",
    "zoho.com",
];

const DOMAINS = [...new Set([...COMMON_DOMAINS, ...POPULAR_DOMAINS])];

// Mistyped .com/.net/.org endings. The library's closest-match pick turns
// these into real but unlikely endings (.con -> .co, .nte -> .it), so fix them
// first.
const TLD_TYPOS = {
    con: "com",
    cm: "com",
    cmo: "com",
    ocm: "com",
    vom: "com",
    xom: "com",
    comm: "com",
    coom: "com",
    nte: "net",
    ner: "net",
    nett: "net",
    ogr: "org",
    orgg: "org",
};

// The corrected email, or null when it looks fine (or isn't an email yet).
export function suggestEmail(email) {
    const value = (email ?? "").trim();
    const at = value.lastIndexOf("@");
    if (at < 1 || at === value.length - 1) {
        return null;
    }

    const local = value.slice(0, at);
    const typed = value.slice(at + 1).toLowerCase();

    let domain = typed;
    const dot = domain.lastIndexOf(".");
    const tld = TLD_TYPOS[domain.slice(dot + 1)];
    if (dot > 0 && tld) {
        domain = `${domain.slice(0, dot)}.${tld}`;
    }

    const result = EmailSpellChecker.run({
        email: `${local}@${domain}`,
        domains: DOMAINS,
        topLevelDomains: POPULAR_TLDS,
    });
    const fixed = result ? result.domain : domain;

    // Keep the name as typed; the library lowercases the whole address.
    return fixed !== typed ? `${local}@${fixed}` : null;
}
